import FileItem from '@adsk/bim360-matrix-react-file-item';
import IssueAttachmentName from './IssueAttachmentName';
import React from 'react';
import {attachmentAttributesType} from '../../constants/proptype-validation';
import PropTypes from 'prop-types';
import useOpenAttachment from './useOpenAttachment';
import {connect} from '../../app/connect';
import {getThumbnailUrlByAttachment} from '../../app/selectors';

const IssueAttachmentFileItem = ({attachment, dispatch, thumbnailUrl, container}) => {
  const openAttachment = useOpenAttachment({attachment, dispatch});
  return (
    <FileItem
      className="IssueAttachmentFileItem"
      thumbnailUrl={thumbnailUrl}
      topBarRenderer={FileItem.clickableTopBar(openAttachment)}
    >
      <IssueAttachmentName attachment={attachment} container={container} />
    </FileItem>
  );
};

IssueAttachmentFileItem.displayName = 'IssueAttachmentFileItem';
IssueAttachmentFileItem.propTypes = {
  attachment: attachmentAttributesType.isRequired,
  thumbnailUrl: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  container: PropTypes.object
};

const mapStateToProps = (state, ownProps) => ({
  thumbnailUrl: getThumbnailUrlByAttachment(state, ownProps.attachment)
});

export default connect(mapStateToProps)(IssueAttachmentFileItem);
